import './post_view.js.coffee';# Added by Script 
Namespace 'Monitoring.Reports.DailyInsights'

class Monitoring.Reports.DailyInsights.TwitterPostView extends Monitoring.Reports.DailyInsights.PostView
  preview: JST['backbone/templates/monitoring/reports/daily_insights/post_preview_twitter']

  customRender: =>
    @$('[data-view=post-preview]').append(@preview(@options.post))
    @sections.push(new Monitoring.Reports.DailyInsights.TwitterMetricsView(@options))
